var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListDragIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33398 5.16681C3.33398 4.61452 3.7817 4.16681 4.33398 4.16681H16.334C16.8863 4.16681 17.334 4.61452 17.334 5.16681C17.334 5.71909 16.8863 6.16681 16.334 6.16681H4.33398C3.7817 6.16681 3.33398 5.71909 3.33398 5.16681Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33398 10.1668C3.33398 9.61452 3.7817 9.16681 4.33398 9.16681H16.334C16.8863 9.16681 17.334 9.61452 17.334 10.1668C17.334 10.7191 16.8863 11.1668 16.334 11.1668H4.33398C3.7817 11.1668 3.33398 10.7191 3.33398 10.1668Z",
    fill: "#23242A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33398 15.1668C3.33398 14.6145 3.7817 14.1668 4.33398 14.1668H16.334C16.8863 14.1668 17.334 14.6145 17.334 15.1668C17.334 15.7191 16.8863 16.1668 16.334 16.1668H4.33398C3.7817 16.1668 3.33398 15.7191 3.33398 15.1668Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDragIcon);
export default __webpack_public_path__ + "static/media/list-drag-icon.55a82537a2feb5a06c1de3fd04d89f40.svg";
export { ForwardRef as ReactComponent };